.tooltipContentStyle {
  font-size: 14px;
  background: var(--tractie-color-background-default-inverse);
  color: var(--tractie-color-content-default-inverse);
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.16),
    0 2px 12px rgba(0, 0, 0, 0.24);
  padding: 12px 16px;
  z-index: 10;
  max-width: 280px;
  border-radius: 3px;
}

.hideTooltipStyle {
  opacity: 0;
}

.tooltipArrowStyle {
  fill: var(--tractie-color-background-default-inverse);
}
